module.exports = __webpack_public_path__ + "static/media/flatbread-logo.b94a3a37.svg";